import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useState, useEffect, useRef } from 'react';
import { getAllCategories } from '../../api/product-api';

function Department({ isDropdownOpen, setIsDropdownOpen }) {
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [category, setCategory] = useState('');
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);
  const toggleDropdown = () => setIsDropdownOpen((prev) => !prev);

  useEffect(() => {
    const path = window.location.pathname;
    const segments = path.split('/').filter(Boolean);
    setCategory(segments[0]);
  }, []);

  const { data } = useQuery({
    queryKey: ['categories'],
    queryFn: () => getAllCategories(),
  });
  const categories = Array.isArray(data?.data?.categories)
    ? data.data.categories
    : [];

  const handleDepartmentClick = (department) => {
    setSelectedDepartment(department);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.target) &&
        !buttonRef.current.contains(e.target)
      ) {
        setIsDropdownOpen(false);
        setSelectedDepartment(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = 'auto';
    };
  }, [isDropdownOpen]);

  const handleClose = () => {
    setIsDropdownOpen(false);
  };

  const overlayStyle =
    buttonRef.current && isDropdownOpen
      ? {
          top: `${buttonRef.current?.getBoundingClientRect().bottom}px`,
          left: 0,
          right: 0,
          bottom: 0,
          position: 'fixed',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 20,
        }
      : {};

  return (
    <div className="relative md:block">
      <button
        onClick={toggleDropdown}
        ref={buttonRef}
        className="cursor-pointer flex space-x-1 p-2 rounded-[20px] font-medium text-xs border border-black px-5 items-center hover:bg-gray-100 transition-colors duration-200 z-40"
      >
        <img src="/images/category-alt.svg" alt="category icon" width={15} />

        <p className="  font-semibold">Department</p>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="6"
          viewBox="0 0 12 6"
          fill="none"
        >
          <path
            d="M5.99998 5.625C5.80302 5.62534 5.60794 5.58676 5.42594 5.51146C5.24394 5.43617 5.07862 5.32564 4.93948 5.18625L0.969727 1.21575L2.03023 0.15525L5.99998 4.125L9.96973 0.15525L11.0302 1.21575L7.06048 5.1855C6.92139 5.32503 6.7561 5.43569 6.5741 5.51112C6.3921 5.58654 6.19699 5.62524 5.99998 5.625Z"
            fill="#222224"
          />
        </svg>
      </button>
      {isDropdownOpen && (
        <>
          <div style={overlayStyle} onClick={toggleDropdown} />

          <div
            ref={dropdownRef}
            className="fixed bg-white rounded-b-[10px] shadow-lg z-30 flex"
            style={{
              top: `${buttonRef.current?.getBoundingClientRect().bottom}px`,
              left: `${buttonRef.current?.getBoundingClientRect().left}px`,
            }}
          >
            <div className="py-2 w-64">
              <h3 className="  font-semibold text-sm px-4">All Departments</h3>
              <hr className="my-2 mx-4" />
              <ul className="mt-2 space-y-2">
                {/* {categories?.map((cat) => (
                  <li
                    key={cat?.name}
                    onClick={() => handleDepartmentClick(cat)}
                    className={`  cursor-pointer py-1 transition-all duration-200 ease-in-out 
                          ${cat?.name === selectedDepartment?.name ? 'font-semibold bg-[#FFF8CF]' : ''} 
                          ${cat?.name === 'Sales & Offers' ? 'text-[#DB1C5E] ' : 'text-gray-800'} 
                          hover:bg-[#FFF8CF] hover:scale-101 hover:shadow-sm 
                          focus: outline-none focus:bg-[#FFF8CF] focus:scale-101 focus:shadow-sm`}
                    tabIndex={0}
                    onKeyDown={(e) =>
                      e.key === 'Enter' && handleDepartmentClick(cat)
                    }
                  >
                    <span className="px-4">{cat?.name}</span>
                  </li>
                ))} */}
                {categories?.map((cat) => {
                  const isDisabled = [
                    'Real Estate',
                    'Education & Training',
                    'Automotive',
                  ].includes(cat?.name);

                  return (
                    <li
                      key={cat?.name}
                      onClick={() => !isDisabled && handleDepartmentClick(cat)}
                      className={`cursor-pointer py-1 transition-all duration-200 ease-in-out
        ${cat?.name === selectedDepartment?.name ? 'font-semibold bg-[#FFF8CF]' : ''} 
        ${cat?.name === 'Sales & Offers' ? 'text-[#DB1C5E]' : 'text-gray-800'} 
        ${isDisabled ? 'opacity-50 cursor-not-allowed' : 'hover:bg-[#FFF8CF] hover:scale-101 hover:shadow-sm'} 
        focus:outline-none focus:bg-[#FFF8CF] focus:scale-101 focus:shadow-sm`}
                      tabIndex={isDisabled ? -1 : 0}
                      onKeyDown={(e) =>
                        !isDisabled &&
                        e.key === 'Enter' &&
                        handleDepartmentClick(cat)
                      }
                    >
                      <span className="px-4">{cat?.name}</span>
                    </li>
                  );
                })}
              </ul>
            </div>
            {selectedDepartment &&
              selectedDepartment?.subcategories.length > 0 && (
                <div className="py-2 w-64 bg-[#FFF8CF] rounded-b-[10px]">
                  <h3 className="  font-semibold text-sm px-4">
                    {selectedDepartment?.name}
                  </h3>
                  <hr className="border-black my-2 mx-2" />

                  <ul className="mt-3 space-y-4 mx-2 ">
                    {selectedDepartment?.subcategories.map((sub, index) => (
                      <li key={index}>
                        <Link
                          to={`/${selectedDepartment?.slug}/${sub?.slug}`}
                          className="  cursor-pointer  px-2 py-1 text-gray-700 hover:bg-yellow-100 hover:scale-105 hover:shadow-sm transition-all duration-200 ease-in-out focus:outline-none focus:bg-yellow-100 focus:scale-105 focus:shadow-sm focus:underline"
                          tabIndex={0}
                          onKeyDown={(e) => e.key === 'Enter'}
                          onClick={handleClose}
                        >
                          {sub.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
          </div>
        </>
      )}
    </div>
  );
}

export default Department;
